/* eslint-disable @animech/axiom/no-references-in-top-level-values */
/* eslint-disable @animech/axiom/no-unrelated-imports */
/* eslint-disable @animech/axiom/strict-function-syntax */
import { makeLocalization } from "@animech/axiom-format/src/definitions/definition-bindings";
import en from "../../locales/en.json";
import sv from "../../locales/sv.json";
import { root } from "./property-definitions";

// ---------------------------------------------------------------------------
// Locale registry — add new locales here + import above
// ---------------------------------------------------------------------------

export const locales = ["en", "sv"] as const;

// eslint-disable-next-line @animech/axiom/valid-axiom-system-values
export const terms = [
	...Object.keys(en.term).filter((k) => !locales.includes(k as never)),
	// eslint-disable-next-line @animech/axiom/no-references-in-top-level-values
	...locales,
] as const;

// ---------------------------------------------------------------------------
// Assembly helpers
// ---------------------------------------------------------------------------

function toLabelMap<T extends Record<string, string>>(
	section: T,
): { [K in keyof T]: { label: string } } {
	return Object.fromEntries(
		Object.entries(section).map(([k, v]) => [k, { label: v }]),
	) as { [K in keyof T]: { label: string } };
}

function buildProperties(data: typeof en) {
	const themes = toLabelMap(data["value:theme"]);
	const seating = toLabelMap(data["value:seating"]);
	const tables = toLabelMap(data["value:table"]);

	return {
		uiSection: {
			property: root.uiSection,
			main: { label: data.property.uiSection },
			values: {},
		},
		materialThemeDiverged: {
			property: root.materialThemeDiverged,
			main: { label: data.property.materialThemeDiverged },
			values: {},
		},
		materialTheme: {
			property: root.materialTheme,
			main: { label: data.property.materialTheme },
			values: themes,
		},
		tableTheme: {
			property: root.tableTheme,
			main: { label: data.property.tableTheme },
			values: themes,
		},
		tableType: {
			property: root.tableType,
			main: { label: data.property.tableType },
			values: tables,
		},
		chair: {
			chairType: {
				property: root.chair.$.chairType,
				main: { label: data.property.chairType },
				values: seating,
			},
			chairTheme: {
				property: root.chair.$.chairTheme,
				main: { label: data.property.chairTheme },
				values: themes,
			},
			count: {
				property: root.chair.$.count,
				main: { label: data.property.count },
				values: "keep" as const,
			},
		},
		areaDepth: {
			property: root.areaDepth,
			main: { label: data.property.areaDepth },
			values: "keep" as const,
		},
		areaWidth: {
			property: root.areaWidth,
			main: { label: data.property.areaWidth },
			values: "keep" as const,
		},
		flipArea: {
			property: root.flipArea,
			main: { label: data.property.flipArea },
			values: "keep" as const,
		},
	};
}

function buildTranslation(data: typeof en) {
	return {
		properties: buildProperties(data),
		nodes: data.node,
		articles: { categories: {}, items: {} },
		customPropertyMeta: {},
		customPropertyValueMeta: {},
		terms: data.term,
	};
}

// ---------------------------------------------------------------------------
// Localization definition
// ---------------------------------------------------------------------------

export const localization = makeLocalization({
	translations: {
		en: buildTranslation(en),
		sv: buildTranslation(sv),
	},
});
